import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/use-auth";
import { useTranslation } from "react-i18next";
import { LocalRoutesNavTargets } from "@/LocalRoutes";
import { hasAllRequiredRoles } from "@/auth/roles";

export const ProtectedRoute: FC<{
    requiredRoles: string[];
}> = ({ requiredRoles }) => {
    const { t } = useTranslation();
    const { isLoading, isLoggedIn, userInfo } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <span>{t("components.protected-route.is-loading")}</span>;
    } else if (!isLoggedIn) {
        console.warn("not logged in redirect to login");
        return (
            <Navigate
                replace
                state={{ from: location }}
                to={LocalRoutesNavTargets.LOGIN}
            />
        );
    }

    if (!hasAllRequiredRoles(userInfo?.roles ?? [], requiredRoles)) {
        return <Navigate to={LocalRoutesNavTargets.UNAUTHORIZED} />;
    }

    return <Outlet />;
};
